<div class="container py-3">
  <div class="d-flex flex-column flex-md-row align-items-center pb-3 mb-4 border-bottom">
    <a [routerLink]="['/']" class="d-flex align-items-center text-dark text-decoration-none brand-logo">
      <h1>TVöD Gehalt</h1>
      <p>Dein online Gehaltsrechner</p>
    </a>

    <nav class="d-inline-flex mt-2 mt-md-0 ms-md-auto d-none d-md-block">
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/']"> Rechner </a>
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/brutto-netto-rechner']"> Brutto-Netto </a>
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/tariftabellen']"> Tariftabellen </a>
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/blog']"> Blog </a>
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/impressum']"> Impressum </a>
      <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/datenschutz']"> Datenschutz </a>
    </nav>
  </div>
  <router-outlet></router-outlet>
  <hr />
  <footer class="pt-4 my-md-1 pt-md-5 border-top">
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <h2>Infos</h2>
        <ul class="list-unstyled text-small">
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/brutto-netto-rechner']"> Brutto-Netto-Rechner </a>
          </li>
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/tariftabellen']"> Tariftabellen </a>
          </li>
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/blog']"> Blog </a>
          </li>
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/impressum']">Impressum</a>
          </li>
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="['/datenschutz']">Datenschutz</a>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-4">
        <h2>Unterstützen</h2>
        <ul class="list-unstyled text-small">
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" target="_blank" href="https://www.buymeacoffee.com/maxcoffee"> Buy me a coffee </a>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-4">
        <h2>Partner</h2>
        <ul class="list-unstyled text-small">
          <li class="mb-1">
            <a class="me-3 py-2 text-dark text-decoration-none" href="https://metallgehalt.de" target="_blank"> metallgehalt.de </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</div>
